module.exports = __webpack_public_path__ + "static/media/logo-ted.6671ff14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/articles/logo-ted.svg
// module id = 558
// module chunks = 0